import React, { useState, useEffect, useRef } from 'react';
import { useFPS } from '../../context/FpsContext';
import './Fps.css';
import { getIsDebugEnabled } from '../../../../services/LocalStorage';

const HUDFps: React.FC = () => {
  const { subscribe, unsubscribe } = useFPS();
  const [fps, setFPS] = useState<number>(0);
  const isDebugEnabled = useRef<boolean>(getIsDebugEnabled());

  useEffect(() => {
    const handleFPSUpdate = (fpsValue: number) => {
      setFPS(fpsValue);
    };

    subscribe(handleFPSUpdate);
    return () => {
      unsubscribe(handleFPSUpdate);
    };
  }, [subscribe, unsubscribe]);

  if (!isDebugEnabled.current) {
    return null;
  }

  return (
    <div className="hud-fps-container">
      FPS: {fps.toFixed(2)}
    </div>
  );
};

export default HUDFps;
